import {createSlice} from "@reduxjs/toolkit";

const initialScrimListState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  contestData: [], 
  contestUsers: [], 
  retentionreportlist: [],
  gameList: [],
  gameTypeList: [],
  company: [],
  upload: {},
  // hostListList: [],
  // imageField : undefined,
  screenShots: [], 
  totalJoinedPlayers: 0,
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const NewScrimSlice = createSlice({
  
  name: "newScrimList",
  initialState: initialScrimListState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    hostListList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice",totalCount, entities)
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    contestDetails: (state, action) => {
      const { contestData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestData = contestData;
    },
    contestUsersList: (state, action) => {
      const { contestUsers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestUsers = contestUsers;
    },
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
    },
    gameTypeList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameTypeList = entities;
    },
    contestsExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    company: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.company = entities;
      // state.totalCount = totalCount;
  },
  itemUpdated: (state, action) => {
    state.error = null;
    state.actionsLoading = false;
    state.entities = [];
  },
    // imageUploaded: (state, action) => {
    //   const { entities, imageField} = action.payload;
    //   // console.log('in e',entities)
    //   // console.log('in f',imageField)

    //   state.error = null;
    //   state.upload = entities;
    //   state.imageField = imageField;
    // },
    saveScreenShot: (state, action) => {
      const { screenShots } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.screenShots = screenShots;
    },
    saveIsHackingProof: (state, action) => {
      const { isHackingProofImages } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.isHackingProofImages = isHackingProofImages;
    },
    saveTotalJoinedPlayers: (state, action) => {
      const { totalJoinedPlayers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalJoinedPlayers = totalJoinedPlayers;
    }

  }
});


